// Copyright (c) Move Closer 2022.

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export const PRODUCTS_LIST_COMPONENT_KEY = 'ProductsListComponent'

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export const PRODUCTS_LIST_DEFAULT_CONFIG = {
  hasCategoryNavigation: false,
  listDisplayControlsInDrawer: true,
  paginationHasDirectionButtons: true,
  paginationHasGroupedLayout: false,
  shouldImplementMobileHeading: true
}
